// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"8133fb62","263":"c64ee90b","331":"6f4a5af7","519":"2ae91103","693":"02f7f557","932":"59fd9793"}[chunkId] + ".chunk.js";
};